import { collection, query, where, orderBy, onSnapshot, updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function subscribeClientTasks(clientId, onData, onError) {
  const col = collection(db, ...FS.clientTasks(appId));
  const q = query(col, where('clientId', '==', clientId), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => {
    const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    onData(rows);
  }, onError);
}

export async function submitClientTask(taskId) {
  const ref = doc(db, ...FS.clientTasks(appId), taskId);
  await updateDoc(ref, {
    status: 'submitted',
    submittedAt: serverTimestamp(),
  });
}
